'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    justify-content: space-between;\n    margin: 2.37em auto;\n    position: relative;\n  '], ['\n    justify-content: space-between;\n    margin: 2.37em auto;\n    position: relative;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    margin: 3.5em auto 60px;\n  '], ['\n    margin: 3.5em auto 60px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      display: block;\n    '], ['\n      display: block;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      width: auto;\n    '], ['\n      width: auto;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n        padding: 0;\n        text-align: left;\n      '], ['\n        padding: 0;\n        text-align: left;\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n        margin-top: 2.5em;\n      '], ['\n        margin-top: 2.5em;\n      ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      font-size: 1.5em;\n      font-weight: 600;\n    '], ['\n      font-size: 1.5em;\n      font-weight: 600;\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    width: auto;\n    line-height: 1.4;\n  '], ['\n    width: auto;\n    line-height: 1.4;\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    line-height: 1.37;\n    font-size: 2.18em;\n  '], ['\n    line-height: 1.37;\n    font-size: 2.18em;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _H = require('UIComponents/elements/headings/H1');

var _H2 = _interopRequireDefault(_H);

var _PhoneSupport = require('pricing-pages-unified-ui/components/common/PhoneSupport');

var _PhoneSupport2 = _interopRequireDefault(_PhoneSupport);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _responsiveBreakpoints = require('pricing-pages-unified-ui/utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledFlex = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'PhoneSupportFooter__StyledFlex'
})(['margin:140px auto 125px;', ' ', ' &.phone-support-footer{', '}.phone-support-footer__tel{width:350px;', ' .phone-support-container{', ' ', '}}.phone-heading{', '}*{z-index:1;}'], _responsiveBreakpoints2.default.tablet(_templateObject), _responsiveBreakpoints2.default.phone(_templateObject2), _responsiveBreakpoints2.default.tabletPortrait(_templateObject3), _responsiveBreakpoints2.default.tablet(_templateObject4), _responsiveBreakpoints2.default.tabletPortrait(_templateObject5), _responsiveBreakpoints2.default.phone(_templateObject6), _responsiveBreakpoints2.default.tablet(_templateObject7));

var StyledHeading = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'PhoneSupportFooter__StyledHeading'
})(['width:70%;', ' ', ''], _responsiveBreakpoints2.default.tablet(_templateObject8), _responsiveBreakpoints2.default.phone(_templateObject9));

function PhoneSupportFooter(_ref) {
  var phoneSourceId = _ref.phoneSourceId,
      screen = _ref.screen;

  return _react2.default.createElement(
    StyledFlex,
    {
      grow: 2,
      className: 'phone-support-footer',
      align: 'center',
      justify: 'center'
    },
    _react2.default.createElement(
      StyledHeading,
      null,
      _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.stillHaveQuestions' })
    ),
    _react2.default.createElement(
      'div',
      { grow: 1, className: 'phone-support-footer__tel' },
      _react2.default.createElement(_PhoneSupport2.default, {
        screen: screen,
        className: 'phone-support-footer__contents',
        phoneSourceId: phoneSourceId,
        showCopy: false,
        border: false
      })
    )
  );
}

PhoneSupportFooter.propTypes = {
  phoneSourceId: _react.PropTypes.string.isRequired,
  screen: _react.PropTypes.string.isRequired
};

exports.default = PhoneSupportFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/PhoneSupportFooter.js
// module id = 217
// module chunks = 3 4